import React, {useState} from 'react';
import {AlignJustify, X} from 'react-feather';
import MobileMenuDialogDeclare from '../utils/MobileMenuDialogDeclare';
function MobileBurgerMenu() {
    //Burger menu that shows up on the side of the navbar page.
    function handleClick(){
     setActive(!active)
    }
    function CloseDialogue(){
     setActive(!active)
    }
    const [active, setActive] = useState(false)
    
    return (<><div onClick={handleClick}>{active ? <X /> : <AlignJustify />}</div>
    <MobileMenuDialogDeclare  show={active} ClosePopUp = {CloseDialogue} /></>
    );
}


export default MobileBurgerMenu;